/* eslint-disable no-control-regex */
// https://stackoverflow.com/questions/42407785/regex-extract-email-from-strings

const RE_EMAIL =
  /(?:([a-z0-9+!#$%&'*+/=?^_`{|}~-]|\p{L})+(?:\.([äßüöïëa-z0-9!#$%&'*+/=?^_`{|}~-]|\p{L})+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/giu;

export function extractEmails(text) {
  return text.match(RE_EMAIL) || [];
}
